export default function debounce(fn, delay) {
  let timeoutId;
  const debounced = function (...args) {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => {
      fn.apply(this, args);
    }, delay);
  };
  debounced.cancel = () => clearTimeout(timeoutId);
  return debounced;
}
